import { PerformancePage } from "./performance";

export const PerformanceAndUtilization = PerformancePage;
